import React, { useEffect, useRef, useState } from "react";
import Layout from "../../components/Layout";
import {
  API_URL,
  CHAT_URL,
  DEVICE_ID,
  FAST_SPEED,
  JWT_TOKEN,
  MEDIUM_SPEED,
  SLOW_SPEED,
  VERYFAST_SPEED,
  WS_URL,
} from "../../constraints";
import { Canvas } from "@react-three/fiber";
import MachineModel from "../../raw/Raw";
import RenderButton from "./Functionality";
import AnimationMasalaBoxContainer from "../Animated";
import { CameraControls, Text } from "@react-three/drei";
import { MeshStandardMaterial, SpotLight, TextureLoader } from "three";
import { useThree } from "@react-three/fiber";
import { useTexture } from "@react-three/drei";
import Typewriter from "typewriter-effect";
import { io } from "socket.io-client";

const socket = io(WS_URL, {
  transports: ["websocket"],
  auth: { token: JWT_TOKEN },
});

const GridFloor = () => {
  const { scene } = useThree();

  const brickTexture = new TextureLoader().load("./../../assets/brick.jpg");

  const brickMaterial = new MeshStandardMaterial({
    metalnessMap: brickTexture,
    roughness: 0.01,
  });

  useEffect(() => {
    const spotLight = new SpotLight("white", 10000);
    spotLight.position.set(0, 28, 0);
    spotLight.angle = Math.PI / 4;
    spotLight.penumbra = 0.05;
    spotLight.distance = 50;
    spotLight.castShadow = true;
    spotLight.shadow.mapSize.width = 512;
    spotLight.shadow.mapSize.height = 512;

    scene.add(spotLight);

    return () => {
      scene.remove(spotLight);
    };
  }, [scene]);

  return (
    <group>
      {/* Floor */}
      <mesh rotation={[-Math.PI / 2, 0, 0]} position={[0, -1, 0]} receiveShadow>
        <boxGeometry args={[70, 70]} />
        <meshStandardMaterial color={"#01022E"} />
      </mesh>
      {/* Left Wall */}
      <mesh position={[-34.5, 14, 0]} receiveShadow>
        <boxGeometry args={[1, 30, 70]} />
        <meshStandardMaterial color={"#7C0000"} />
      </mesh>
      {/* Right Wall */}
      <mesh position={[34.5, 14, 0]} receiveShadow>
        <boxGeometry args={[1, 30, 70]} />
        <meshStandardMaterial color={"#7C0000"} />
      </mesh>
      {/* Back Wall */}
      <mesh position={[0, 14, 34.5]} receiveShadow>
        <boxGeometry args={[70, 30, 1]} />
        <meshStandardMaterial color={"#7C0000"} />
      </mesh>
      {/* Roof */}
      <mesh position={[0, 29, 0]} receiveShadow>
        <boxGeometry args={[70, 1, 70]} />
        <meshStandardMaterial color={"gray"} />
      </mesh>

      {/* Lights on the roof */}
      <directionalLight
        position={[0, 28, 0]}
        castShadow
        color={"white"}
        visible={true}
        scale={[5, 5, 5]}
      />

      <directionalLight
        position={[0, 0, -15]}
        castShadow
        color={"gray"}
        visible={true}
        scale={[5, 5, 5]}
      />

      <directionalLight
        position={[-34.5, 14, 0]}
        castShadow
        color={"gray"}
        visible={true}
        scale={[5, 5, 5]}
      />

      <directionalLight
        position={[34.5, 14, 0]}
        castShadow
        color={"gray"}
        visible={true}
        scale={[5, 5, 5]}
      />

      <pointLight position={[-30, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, -25]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, -25]} intensity={50} color={"white"} />

      <pointLight position={[-30, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, -15]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, -15]} intensity={50} color={"white"} />

      <pointLight position={[-30, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, -5]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, -5]} intensity={50} color={"white"} />

      <pointLight position={[-30, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, 5]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, 5]} intensity={50} color={"white"} />

      <pointLight position={[-30, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, 15]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, 15]} intensity={50} color={"white"} />

      <pointLight position={[-30, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[-20, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[-10, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[0, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[10, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[20, 28, 25]} intensity={50} color={"white"} />
      <pointLight position={[30, 28, 25]} intensity={50} color={"white"} />
    </group>
  );
};

const ParamScreen = ({
  params: { voltage, current, power, frequency, count },
}: {
  params: {
    voltage: Number;

    current: Number;
    power: Number;
    frequency: Number;
    count: Number;
  };
}) => {
  return (
    <mesh
      // position={[6.7, 3.55, 0.6]}
      position={[10.05, 4.8, -5.7]}
      scale={[3.5, 1.6, 1]}
      rotation={[0, Math.PI, 0]}
    >
      <planeGeometry args={[1, 1]} />
      <meshStandardMaterial
        color="blue"
        attach="material"
        emissive="blue"
        emissiveIntensity={1}
      />
      <Text
        position={[0, 0.35, 0.1]}
        fontSize={0.1}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[Math.PI, Math.PI, Math.PI]}
      >
        Electric Parameters
      </Text>
      <Text
        position={[0, 0.2, 0.1]}
        fontSize={0.08}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[Math.PI, Math.PI, Math.PI]}
      >
        {`Voltage: ${voltage} V`}
      </Text>
      <Text
        position={[0, 0.08, 0.1]}
        fontSize={0.08}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[Math.PI, Math.PI, Math.PI]}
      >
        {`Current: ${current} A`}
      </Text>
      <Text
        position={[0, -0.04, 0.1]}
        fontSize={0.08}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[Math.PI, Math.PI, Math.PI]}
      >
        {`Power: ${power} W`}
      </Text>
      <Text
        position={[0, -0.16, 0.1]}
        fontSize={0.08}
        color="white"
        anchorX="center"
        anchorY="middle"
        rotation={[Math.PI, Math.PI, Math.PI]}
      >
        {`Frequency: ${frequency} Hz`}
      </Text>
    </mesh>
  );
};

const Machine = () => {
  const [isConnected, setIsConnected] = useState(true);
  const [enableAnimation, setEnableAnimation] = useState(true);
  const [animationSpeed, setAnimationSpeed] = useState(0.1);
  const [question, setQuestion] = useState("");
  const [output, setOutput] = useState(<></>);

  const [params, setParams] = useState({
    voltage: 0,
    current: 0,
    power: 0,
    frequency: 0,
    count: 0,
  });

  const voltageCard = useRef<HTMLDivElement>(null);
  const currentCard = useRef<HTMLDivElement>(null);
  const powerCard = useRef<HTMLDivElement>(null);
  const frequencyCard = useRef<HTMLDivElement>(null);
  const countCard = useRef<HTMLDivElement>(null);
  const speedController = useRef<HTMLSelectElement>(null);
  const speedControllerText = useRef<HTMLSelectElement>(null);
  const speedControllerButton = useRef<HTMLButtonElement>(null);

  const submitHandler = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();

    setOutput(<></>);

    const response = await fetch(CHAT_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ question }),
    });

    const data = await response.json();

    if (data.intent === "getMachineStatus") {
      setOutput(
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString(
                `Machine is currently ${
                  data.status ? "on" : "off"
                } with speed of ${data.speed} boxes/min !!`
              )
              .pauseFor(10)
              .start();
          }}
        />
      );
    } else if (data.intent === "getElectricParams") {
      setOutput(
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString(
                `Electric parameters are: \n Voltage: ${data.voltage} V, Current: ${data.current} A, Power: ${data.power} W, Frequency: ${data.frequency} Hz ...`
              )
              .pauseFor(100)
              .start();
          }}
        />
      );
    } else if (data.intent === "switchOnMachine") {
      changeDeviceStatus(1);
      setOutput(
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString("Machine is turned on !!")
              .pauseFor(100)
              .start();
          }}
        />
      );
    } else if (data.intent === "switchOffMachine") {
      changeDeviceStatus(0);
      setOutput(
        <Typewriter
          onInit={(typewriter) => {
            typewriter
              .typeString("Machine is turned off !!")
              .pauseFor(100)
              .start();
          }}
        />
      );
    } else {
      setOutput(
        <Typewriter
          onInit={(typewriter) => {
            typewriter.typeString("Invalid Query !!").pauseFor(100).start();
          }}
        />
      );
    }

    setQuestion("");
  };

  const updateData = async (message: any) => {
    setParams({
      voltage: message.voltage,
      current: message.current,
      power: message.power,
      frequency: message.frequency,
      count: message.count,
    });

    if (message.voltage !== undefined && voltageCard.current !== null) {
      voltageCard.current.innerText = message.voltage;
    }

    if (message.current !== undefined && currentCard.current !== null) {
      currentCard.current.innerText = message.current;
    }

    if (message.power !== undefined && powerCard.current !== null) {
      powerCard.current.innerText = message.power;
    }

    if (message.frequency !== undefined && frequencyCard.current !== null) {
      frequencyCard.current.innerText = message.frequency;
    }

    if (
      message.count !== undefined &&
      countCard.current !== null &&
      speedControllerButton.current !== null &&
      speedControllerText.current !== null
    ) {
      countCard.current.innerText = message.count;
      speedControllerButton.current.disabled = false;

      if (message.count === 0) {
        speedControllerText.current.innerHTML = "Machine is off";
        speedControllerButton.current.disabled = true;
      } else if (message.count === 25) {
        speedControllerText.current.innerHTML = "Slow";
        setAnimationSpeed(SLOW_SPEED);
      } else if (message.count === 50) {
        speedControllerText.current.innerHTML = "Medium";
        setAnimationSpeed(MEDIUM_SPEED);
      } else if (message.count === 75) {
        speedControllerText.current.innerHTML = "Fast";
        setAnimationSpeed(FAST_SPEED);
      } else if (message.count === 100) {
        speedControllerText.current.innerHTML = "Very Fast";
        setAnimationSpeed(VERYFAST_SPEED);
      }
    }
  };

  const preFetchData = async () => {
    const response = await fetch(API_URL, {
      headers: {
        accept: "application/json",
        authorization: `Bearer ${JWT_TOKEN}`,
      },
    });

    const data = await response.json();
    const counter = data.devices.find(
      (device: any) => device._id === `${DEVICE_ID}_Counter`
    );
    const switcher = data.devices.find(
      (device: any) => device._id === `${DEVICE_ID}_Switch`
    );
    const electricParameters = data.devices.find(
      (device: any) => device._id === `${DEVICE_ID}_ElectricParameters`
    );
    let machineStatus = switcher.events[0].status;

    let count = counter.events[0].count;
    let { voltage, current, frequency, power } = electricParameters.events[0];

    return {
      voltage: machineStatus ? voltage : 0,
      current: machineStatus ? current : 0,
      frequency: machineStatus ? frequency : 0,
      power: machineStatus ? power : 0,
      count: machineStatus ? count : 0,
      machineStatus: machineStatus,
    };
  };

  const changeDeviceStatus = async (value: Number) => {
    socket.emit("deviceCmd", {
      deviceId: `${DEVICE_ID}_Switch`,
      status: value,
    });
    setEnableAnimation(!enableAnimation);
    setTimeout(async () => {
      const { machineStatus, count, current, frequency, power, voltage } =
        await preFetchData();

      setIsConnected(Boolean(machineStatus));
      updateData({
        voltage,
        current,
        frequency,
        power,
        count,
      });
    }, 1000);
  };

  const handleSpeedChange = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    socket.emit("deviceCmd", {
      deviceId: `${DEVICE_ID}_Counter`,
      value: Number(speedController.current?.selectedOptions[0].value),
    });

    setTimeout(async () => {
      const { machineStatus, count, current, frequency, power, voltage } =
        await preFetchData();

      setIsConnected(Boolean(machineStatus));
      updateData({
        voltage,
        current,
        frequency,
        power,
        count: Number(speedController.current?.selectedOptions[0].value),
      });
    }, 1000);
  };

  useEffect(() => {
    setTimeout(async () => {
      const { machineStatus, count, current, frequency, power, voltage } =
        await preFetchData();

      setIsConnected(Boolean(machineStatus));
      updateData({
        voltage,
        current,
        frequency,
        power,
        count,
      });
    }, 1000);
    socket.on("deviceEvent", updateData);
  }, []);

  return (
    <Layout activeLink={"Machine"}>
      <div className="container-fluid py-4">
        <div className="row">
          <div className="col-12">
            <div
              className="alert alert-info"
              style={{ color: "black" }}
              role="alert"
            >
              <strong>Alerts !</strong> Here will appear the alerts (if any).
            </div>
          </div>
          <div className="col-xl-7">
            <div
              className="card"
              style={{
                height: 500,
                backgroundColor: "#855141",
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              }}
            >
              <div className="card-body p-0 mt-2">
                <Canvas shadows camera={{ position: [0, 0, 15] }}>
                  <GridFloor />
                  <MachineModel />
                  <ParamScreen params={params} />
                  <AnimationMasalaBoxContainer
                    animationSpeed={animationSpeed}
                    isConnected={isConnected}
                  />
                  <RenderButton
                    onClick={() =>
                      !isConnected
                        ? changeDeviceStatus(1)
                        : changeDeviceStatus(0)
                    }
                    isConnected={isConnected}
                  />

                  <CameraControls />
                  {/* <OrbitControls /> */}
                </Canvas>
              </div>
            </div>
          </div>
          <div className="col-xl-5 ms-auto mt-xl-0 mt-4">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  <div className="card-body p-3">
                    <div className="row">
                      <div className="col-8 my-auto">
                        <div className="numbers">
                          <p className="text-sm mb-0 text-capitalize font-weight-bold opacity-7">
                            Description
                          </p>
                          <h5 className="font-weight-bolder mb-0">
                            Masala Packaging Machine
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body text-center">
                    <h1 className="text-gradient text-primary">
                      <span id="status1" ref={voltageCard}>
                        N/A
                      </span>{" "}
                      <span className="text-lg ms-n2">V</span>
                    </h1>
                    <h6 className="mb-0 font-weight-bolder">Voltage</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-md-0 mt-4">
                <div className="card">
                  <div className="card-body text-center">
                    <h1 className="text-gradient text-primary">
                      {" "}
                      <span id="status2" ref={currentCard}>
                        N/A
                      </span>{" "}
                      <span className="text-lg ms-n1">A</span>
                    </h1>
                    <h6 className="mb-0 font-weight-bolder">Current</h6>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-body text-center">
                    <h1 className="text-gradient text-primary">
                      <span id="status3" ref={powerCard}>
                        N/A
                      </span>{" "}
                      <span className="text-lg ms-n2">W</span>
                    </h1>
                    <h6 className="mb-0 font-weight-bolder">Power</h6>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-md-0 mt-4">
                <div className="card">
                  <div className="card-body text-center">
                    <h1 className="text-gradient text-primary">
                      <span id="status4" ref={frequencyCard}>
                        N/A
                      </span>{" "}
                      <span className="text-lg ms-n2">Hz</span>
                    </h1>
                    <h6 className="mb-0 font-weight-bolder">Frequency</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-4" style={{ height: "300px" }}>
          <div className="col-lg-6 mt-lg-0 mt-4">
            <div className="row">
              <div className="col-sm-6">
                <div className="card h-100">
                  <div className="card-body p-3">
                    <h6>Usage</h6>
                    <div className="card h-100">
                      <div
                        className="card-body h-100 d-flex justify-content-center align-items-center"
                        style={{ flexDirection: "column" }}
                      >
                        <h1 className="text-gradient text-primary">
                          <span
                            style={{ fontSize: "80px" }}
                            id="status4"
                            ref={countCard}
                          >
                            N/A
                          </span>{" "}
                          <span className="text-lg ms-n2">packets</span>
                        </h1>
                        <h6 className="mb-0 font-weight-bolder">Count</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-6 mt-sm-0 mt-4">
                <div className="card h-100">
                  <div className="card-body text-center p-3">
                    <h6 className="text-start">Machine Speed</h6>
                    <div className="card h-100 shadow">
                      <div className="card-body">
                        <form>
                          <div className="form-group">
                            <label></label>
                            <div className="row ps-3 pe-3">
                              <small
                                id="helpId"
                                className="form-text text-muted"
                                style={{ color: "white" }}
                              >
                                Current:{" "}
                                <span
                                  style={{ fontWeight: "bolder" }}
                                  ref={speedControllerText}
                                >
                                  0
                                </span>
                              </small>
                              <select
                                ref={speedController}
                                className="form-control"
                                placeholder="Speed"
                              >
                                <option value="0">Change speed</option>
                                <option value="25">Slow</option>
                                <option value="50">Medium</option>
                                <option value="75">Fast</option>
                                <option value="100">Very Fast</option>
                              </select>
                              <button
                                type="submit"
                                className="btn mt-2  w-100 btn-dark"
                                onClick={handleSpeedChange}
                                ref={speedControllerButton}
                              >
                                Save
                              </button>
                            </div>

                            <small id="helpId" className="form-text text-muted">
                              Operate the machine according to the selected
                              speed.
                            </small>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 mt-lg-0 mt-4">
            <div className="card h-100">
              <div className="card-body p-3">
                <h6>Query ?</h6>
                <div className="card shadow h-100">
                  <div className="card-body">
                    <form className="form-inline">
                      <div className="form-group py-0 my-0">
                        <div className="row px-2 py-0 my-0">
                          <div className="col-11 px-0">
                            <input
                              type="text"
                              name=""
                              id=""
                              className="form-control query-txt"
                              placeholder="Ask here !"
                              aria-describedby="helpId"
                              value={question}
                              onChange={(e) => setQuestion(e.target.value)}
                            />
                          </div>
                          <div className="col-1 ps-0 ">
                            <button
                              onClick={submitHandler}
                              type="submit"
                              className="w-100 px-0 mx-0 btn btn-dark query-btn"
                            >
                              <i
                                className="fa fa-chevron-right"
                                aria-hidden="true"
                              ></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                    <p className="p-0 m-0">
                      <b>Output:</b>
                      {output}
                      {/* <p dangerouslySetInnerHTML={{ __html: output }}></p> */}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="horizontal dark my-5" />
      </div>
    </Layout>
  );
};

export default Machine;
